import React from "react";

// DataSourceFooter — single-line provenance disclosure shown at the
// bottom of the property list pane (#audit-9).
//
// Audit's exact complaint:
//   "No data sourcing explanation — where does this data come from?
//    How fresh is it? The absence of this information makes a serious
//    investor suspicious. If I'm bidding at auction based on this data
//    and it's 3 months stale, I lose money."
//
// Trust signal in <60 chars. Updated when our cron schedule changes —
// keep in sync with `.github/workflows/scrape-cron.yml`.

const DataSourceFooter: React.FC = () => (
  <div className="data-source-footer" role="contentinfo">
    Data: NC AOC court records · sync-arcgis ·{" "}
    <span className="data-source-footer__freshness">
      updated 7am & 7pm EST
    </span>
  </div>
);

export default DataSourceFooter;
